import sendRequest from "../fetch"
import api from '../url'
import { cleanParams } from "@/utils";

const _base = "jwStudentCheckin/";

// 学生报到 - 列表
export const checkinPage = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "page", {
    data: _params,
    method: "GET",
  });
};

// 学生报到 - 添加
export const checkinAdd = (params) => {
  let _params = cleanParams(params);
  return sendRequest(api.url + _base + "add", {
    data: _params,
    method: "POST",
  });
};



// WEBPACK FOOTER //
// ./src/fetch/api/checkIn.js